var React = require('react');

function EventInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"13.5","cy":"13.5","r":"12.5","fill":"white","stroke":"#808080","strokeWidth":"2","key":0}),React.createElement("circle",{"cx":"13.5","cy":"13.5","r":"8.5","fill":"#105E94","key":1})]);
}

EventInline.defaultProps = {"width":"27","height":"27","viewBox":"0 0 27 27","fill":"none"};

module.exports = EventInline;

EventInline.default = EventInline;
